import { render, staticRenderFns } from "./SubCategoryStatus.vue?vue&type=template&id=21be1564&"
import script from "./SubCategoryStatus.vue?vue&type=script&lang=js&"
export * from "./SubCategoryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports